import { DefaultButton, Stack } from "office-ui-fabric-react";
import { DetailsListLayoutMode } from 'office-ui-fabric-react/lib/DetailsList';
import {
    DetailsList,
    Icon,
    Persona,
    PersonaSize,
    PrimaryButton,
    SelectionMode,
    TextField,
    Checkbox,
    Text,
    ComboBox,
    Spinner
} from "office-ui-fabric-react/lib/index";
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import React, { Component } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Popup from "reactjs-popup";
import { mutationDeleteUser, mutationUpdateUser, mutationResetUser, queryGetConfigData, queryGetAWSRegions, getStorageData } from "../../../queries/querySettings";
import RuleSwitch from "../RuleList/RuleSwitch";
import { MyContext } from '../../../context';
import { Dropdown, DropdownMenuItemType, IDropdownStyles, IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import { Modal, IconButton } from 'office-ui-fabric-react';
import { Query } from "@apollo/react-components";

const checkboxStyles = () => {
    return {
        root: {
            marginTop: '10px'
        }
    };
};

const dropdownStyles: Partial<IDropdownStyles> = {
    dropdown: { width: 250 }
};

const classNames = mergeStyleSets({
    fileIconHeaderIcon: {
        padding: 0,
        fontSize: '16px'
    },
    fileIconCell: {
        textAlign: 'center',
        selectors: {
            '&:before': {
                content: '.',
                display: 'inline-block',
                verticalAlign: 'middle',
                height: '100%',
                width: '0px',
                visibility: 'hidden'
            }
        }
    },
    fileIconImg: {
        verticalAlign: 'middle',
        maxHeight: '20px',
        maxWidth: '20px'
    },
    controlWrapper: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    exampleToggle: {
        display: 'inline-block',
        marginBottom: '10px',
        marginRight: '30px'
    },
    selectionDetails: {
        marginBottom: '20px'
    }
});

const contentStyles = mergeStyleSets({
    container: {
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'stretch',
    },
    header: [
        {
            flex: '1 1 auto',
            borderTop: '4px solid blue',
            // color: theme.palette.neutralPrimary,
            display: 'flex',
            // fontSize: FontSizes.xLarge,
            alignItems: 'center',
            // fontWeight: FontWeights.semibold,
            padding: '12px 12px 14px 24px',
        },
    ],
    body: {
        flex: '4 4 auto',
        padding: '0 24px 24px 24px',
        overflowY: 'hidden',
        selectors: {
            p: {
                margin: '14px 0',
            },
            'p:first-child': {
                marginTop: 0,
            },
            'p:last-child': {
                marginBottom: 0,
            },
        },
    },
});

const iconButtonStyles = mergeStyleSets({
    root: {
        marginLeft: 'auto',
        marginTop: '4px',
        marginRight: '2px',
    }
});

export default class UserConfigContent extends Component {

    state =
        {
            changed: false,
            rulesAnalytics: this.props.data.user.length > 1 ? null : (this.props.data.user[0].analytics != null ? this.props.data.user[0].analytics.split(',') : []),
            rulesAccess: this.props.data.user.length > 1 ? null : this.props.data.user[0].access,
            rulesRecording: this.props.data.user.length > 1 ? null : this.props.data.user[0].recordingRules,
            rulesReplay: this.props.data.user.length > 1 ? null : this.props.data.user[0].replay,
            addOnAnalytics: this.props.data.user.length > 1 ? null : this.props.data.user[0].addOnAnalytics,
            addOnAIEntry: this.props.data.user.length > 1 ? null : this.props.data.user[0].addOnAIEntry,
            addOnFullChat: this.props.data.user.length > 1 ? null : this.props.data.user[0].addOnFullChat,
            addOnZoom: this.props.data.user.length > 1 ? null : this.props.data.user[0].addOnZoom,
            addOnGenesys: this.props.data.user.length > 1 ? null : this.props.data.user[0].addOnGenesys,
            addOnRingcentral: this.props.data.user.length > 1 ? null : this.props.data.user[0].addOnRingcentral,
            addOnCloud9: this.props.data.user.length > 1 ? null : this.props.data.user[0].addOnCloud9,
            addOnDynamics: this.props.data.user.length > 1 ? null : this.props.data.user[0].addOnDynamics,
            addOnWebex: this.props.data.user.length > 1 ? null : this.props.data.user[0].addOnWebex,
            addOnCompliance: this.props.data.user.length > 1 ? null : this.props.data.user[0].addOnCompliance,
            addOnQualityManagement: this.props.data.user.length > 1 ? null : this.props.data.user[0].addOnQualityManagement,
            addOnCaseManagement: this.props.data.user.length > 1 ? null : this.props.data.user[0].addOnCaseManagement,
            addOnLeapXpert: this.props.data.user.length > 1 ? null : this.props.data.user[0].addOnLeapXpert,
            addOnEmail: this.props.data.user.length > 1 ? null : this.props.data.user[0].addOnEmail,
            addOnMsftTeamsVoice: this.props.data.user.length > 1 ? null : this.props.data.user[0].addOnMsftTeamsVoice,
            addOnMsftTeamsUC: this.props.data.user.length > 1 ? null : this.props.data.user[0].addOnMsftTeamsUC,
            addOnRealTimeTranscript: this.props.data.user.length > 1 ? null : this.props.data.user[0].addOnRealTimeTranscript,
            size: this.props.data.user.length,
            regionalStorageLocation: this.props.data.user.length > 1 ? "" : this.props.data.user[0].regionalStorageLocation,
            regionalStorageCustomLocation: this.props.data.user.length > 1 ? "" : this.props.data.user[0].regionalStorageCustomLocation,
            integrationUser: this.props.data.user.length > 1 ? "" : this.props.data.user[0].integrationUser,
            showModal: false,
            awsAccessKeyId: this.props.data.user.length > 1 ? "" : this.props.data.user[0].awsAccessKeyId,
            awsSecretAccess: this.props.data.user.length > 1 ? "" : this.props.data.user[0].awsSecretAccess,
            awsBucketName: this.props.data.user.length > 1 ? "" : this.props.data.user[0].awsBucketName,
            awsRegion: this.props.data.user.length > 1 ? "" : this.props.data.user[0].awsRegion,
            awsServiceUrl: this.props.data.user.length > 1 ? "" : this.props.data.user[0].awsServiceUrl,
            awsType: this.props.data.user.length > 1 ? "" : this.props.data.user[0].awsType,
            licenseType: this.props.data.user.length > 1 ? "" : this.props.data.user[0].license,
            storageId: this.props.data.user.length > 1 ? "" : this.props.data.user[0].storageId,
            employeeId: this.props.data.user.length > 1 ? "" : this.props.data.user[0].employeeId,
            onPremisesSamAccountName: this.props.data.user.length > 1 ? "" : this.props.data.user[0].onPremisesSamAccountName,
        };

    render() {

        return this.userPanelContent();
    }
    userPanelContent = () => {

        return (
            <div>
                {this.showInfo(this.props.data.user)}
                <hr />
                {this.renderLicense()}
                {this.renderRules()}
                {/*{this.props.userRules.ruleAccess != null && this.props.userRules.ruleAccess.confMapUser && this.renderUserMapping()}*/}
                {this.renderOptions()}
            </div>
        );

    };
    showInfo = (user) => {
        if (user.length === 1) {


            let userContent = {
                name: user[0].name,
                department: user[0].department,
                office: user[0].department,
                superviser: "",
                street: "",
                city: "",
                zip: "",
                country: ""
            };


            return (<MyContext.Consumer>
                {(context) => (
                    <div>
                        <Persona text={userContent.name} size={PersonaSize.size32} />
                        {user.length < 2 && user[0].groupId != null && <Text>{context.getTranslation("configuration", "member")}{user[0].groupName}</Text>}
                    </div>
                )}</MyContext.Consumer>
            );

        } else {

            return (
                <div>
                    {user.map(({ name }, i) => {
                        return (
                            <Persona
                                key={i}
                                size={PersonaSize.size32}
                                id={i}
                                text={name}
                            />
                        );
                    })}
                </div>
            );

        }
    }

    toggleSaveButton = (newRules) => {
        if (this.state.changed === false) {
            this.setState({ changed: true });
        }
        this.setState(newRules);
    };
    _closeModal = () => {
        this.setState({ showModal: false });
    }

    _openModal = () => {
        this.setState({ showModal: true });
    }


    renderRules = () => {
        console.log(this.props.tenantData);
        return <MyContext.Consumer>
            {(context) => (
                <div style={{ padding: "5px" }}>
                    <hr />
                    <h4>{context.getTranslation("configuration", "rules")}</h4>
                    <RuleSwitch data={this.props.data} action={this.toggleSaveButton} userRules={this.props.userRules} profileData={this.props.profileData} licenseType={this.state.licenseType} />
                    <Stack>

                        <Query
                            query={getStorageData}
                            variables={{}}
                        >
                            {({ loading, error, data }) => {
                                if (loading) {
                                    return (
                                        <div style={{ float: "left", "margin-left": "50px" }}>
                                            <Spinner label={context.getTranslation("common", "loading")} ariaLive="assertive" labelPosition="top" />
                                        </div>
                                    );
                                }


                                if (error) return <h4>Failed to connect</h4>;
                                if (data.getStorageData == null) {
                                    return <div />;
                                }
                                let storagesList = [];
                                if (data.getStorageData != null) {

                                    storagesList.push({
                                        key: "none",
                                        text: context.getTranslation("tenants", "noStorageSelected"),
                                    });

                                    if (this.props.data.user.length > 0 && this.props.data.user[0].storageId !== null && this.props.data.user[0].storageId !== undefined) {

                                        let currentStorage = data.getStorageData.find(obj => obj.id === this.state.storageId);
                                        for (var j = 0; j < data.getStorageData.length; j++) {

                                            //if user has a storage assiged that is no longer visible for assignemnt
                                            //he can see that has the storage assigend but will no longer be able to select it again if it's not visible for assignment
                                            if (!currentStorage && this.state.storageId !== "") {
                                                let findSetStorage = this.props.storageData.find(obj => obj.id === this.state.storageId);

                                                if (findSetStorage) {
                                                    storagesList.push({
                                                        key: this.state.storageId,
                                                        text: findSetStorage.displayName,
                                                        disabled: true,
                                                        hidden: true

                                                    });
                                                }
                                            }


                                            storagesList.push({
                                                key: data.getStorageData[j].id,
                                                text: data.getStorageData[j].displayName

                                            });
                                        }
                                    } else {
                                        for (var i = 0; i < data.getStorageData.length; i++) {

                                            storagesList.push({
                                                key: data.getStorageData[i].id,
                                                text: data.getStorageData[i].displayName,
                                                disabled: false

                                            });
                                        }
                                    }
                                }
                                return <Dropdown
                                    label={context.getTranslation("tenants", "storage")}
                                    styles={dropdownStyles}
                                    onChange={(event, newValue) => {
                                        this.setState({
                                            storageId: newValue.key === "none" ? null : newValue.key,
                                            changed: true
                                        })
                                    }}
                                    defaultSelectedKey={!this.state.storageId ? "none" : this.state.storageId}
                                    options={storagesList}
                                />

                            }}

                        </Query>
                        {(this.props.data.user.length > 0 && this.state.regionalStorageLocation && !this.props.data.user[0].storageId) && <>
                            <ComboBox
                                style={{ width: "300px" }}
                                disabled={true}
                                placeholder="Select an option"
                                label="Old Storage"
                                options={[{
                                    key: "Unknown",
                                    text: "Unknown"
                                },
                                {
                                    key: "Emea",
                                    text: "EMEA GRS",
                                },
                                {
                                    key: "UkSouth",
                                    text: "UK South GRS",
                                },
                                {
                                    key: "Apac",
                                    text: "APAC GRS",
                                },
                                {
                                    key: "Americas",
                                    text: "Americas GRS",
                                },
                                {
                                    key: "Brazil",
                                    text: "Brazil GRS",
                                },
                                {
                                    key: "Canada",
                                    text: "Canada GRS",
                                },
                                {
                                    key: "Japan",
                                    text: "Japan GRS",
                                },
                                {
                                    key: "Switzerland",
                                    text: "Switzerland GRS",
                                },
                                {
                                    key: 'UAENorth',
                                    text: "UAE North GRS"
                                },

                                {
                                    key: "LrsEmea",
                                    text: "EMEA LRS",
                                },
                                {
                                    key: "LrsUkSouth",
                                    text: "UK South LRS",
                                },
                                {
                                    key: "LrsApac",
                                    text: "APAC LRS",
                                },
                                {
                                    key: "LrsAmericas",
                                    text: "Americas LRS",
                                },
                                {
                                    key: "LrsBrazil",
                                    text: "Brazil LRS",
                                },
                                {
                                    key: "LrsCanada",
                                    text: "Canada LRS",
                                },
                                {
                                    key: "LrsJapan",
                                    text: "Japan LRS",
                                },
                                {
                                    key: "LrsSwitzerland",
                                    text: "Switzerland LRS",
                                },
                                {
                                    key: 'LrsUAENorth',
                                    text: "UAE North LRS"
                                },
                                {
                                    key: "GrsSwiss",
                                    text: "Swiss GRS",
                                },
                                {
                                    key: "ZrsSingapore",
                                    text: "Singapore Zrs",
                                },
                                {
                                    key: "ApacSe",
                                    text: "APAC Southeast GRS",
                                },
                                {
                                    key: "S3Storage",
                                    text: "S3�Storage",
                                },
                                {
                                    key: "CustomStorage",
                                    text: "Own Storage",
                                }]
                                }
                                selectedKey={this.state.regionalStorageLocation}
                            />

                            {this.state.regionalStorageLocation === "CustomStorage" &&
                                <TextField value={this.state.regionalStorageCustomLocation} label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "storageConnectionString")}</>)}</MyContext.Consumer>}
                                    disabled
                                />}
                            {this.state.regionalStorageLocation === 'S3Storage' && <>
                                <ComboBox
                                    style={{ width: "300px" }}
                                    placeholder="Select an option"
                                    label={context.getTranslation("configuration", "awsType")}
                                    options={[
                                        { key: "Cloud", text: "Cloud" },
                                        { key: "OnPremise", text: "On-premise" },

                                    ]}
                                    selectedKey={this.state.awsType}
                                    onChange={(ev, newVal) => {
                                        this.setState({
                                            awsType: newVal.key,
                                            changed: true
                                        });
                                    }}
                                    disabled={true}
                                />
                                <TextField
                                    type={"text"}
                                    label={context.getTranslation("configuration", "awsAccessKeyId")}
                                    value={this.state.awsAccessKeyId}
                                    disabled={true}
                                    onChange={(event, newValue) => {
                                        this.setState({
                                            awsAccessKeyId: newValue,
                                            changed: true
                                        });
                                    }}
                                />
                                <TextField
                                    type={"text"}
                                    label={context.getTranslation("configuration", "awsSecretAccess")}
                                    value={this.state.awsSecretAccess}
                                    disabled={true}
                                    onChange={(event, newValue) => {
                                        this.setState({
                                            awsSecretAccess: newValue,
                                            changed: true
                                        });
                                    }}
                                />
                                {this.state.awsType == "OnPremise" &&
                                    <TextField
                                        type={"text"}
                                        label={context.getTranslation("configuration", "awsServiceUrl")}
                                        value={this.state.awsServiceUrl}
                                        disabled={true}
                                        onChange={(event, newValue) => {
                                            this.setState({
                                                awsServiceUrl: newValue,
                                                changed: true
                                            });
                                        }}
                                    />}
                                <TextField
                                    type={"text"}
                                    label={context.getTranslation("configuration", "awsBucketName")}
                                    value={this.state.awsBucketName}
                                    disabled={true}
                                    onChange={(event, newValue) => {
                                        this.setState({
                                            awsBucketName: newValue,
                                            changed: true
                                        });
                                    }}
                                />
                                {this.state.awsType === "Cloud" &&
                                    <Query
                                        query={queryGetAWSRegions}
                                        variables={this.props.authorization} >
                                        {({ loading, error, data }) => {
                                            if (loading) return <div>
                                                <Spinner label={context.getTranslation("common", "loadingRegions")} ariaLive="assertive" labelPosition="top" />
                                            </div>;
                                            if (error) return <h1> </h1>;

                                            if (data.getAWSRegions == null) {
                                                return <div></div>;
                                            }
                                            this.tmpKey = [];
                                            const stack = data.getAWSRegions;
                                            if (data.getAWSRegions != null) {
                                                for (let x = 0; x < stack.length; x++) {
                                                    let i = {
                                                        key: stack[x].code,
                                                        text: stack[x].displayName,
                                                    };
                                                    this.tmpKey.push(i);
                                                }
                                            }

                                            return <ComboBox
                                                style={{ width: "300px" }}
                                                placeholder="Select an option"
                                                label={context.getTranslation("configuration", "defaultRegion")}
                                                options={this.tmpKey}
                                                selectedKey={this.state.awsRegion}
                                                onChange={(ev, newVal) => {
                                                    this.setState({
                                                        awsRegion: newVal.key,
                                                        changed: true
                                                    });
                                                }}
                                                disabled={true}
                                            />
                                        }}
                                    </Query>}

                            </>}
                        </>}


                    </Stack>
                    {this.props.tenantData?.addOnMsftTeamsVoice ?
                        <Checkbox
                            label={context.getTranslation("tenants", "addOnMsftTeamsVoice")}
                            checked={this.state.addOnMsftTeamsVoice}
                            styles={checkboxStyles}
                            onChange={(event, newValue) => {
                                this.setState({
                                    addOnMsftTeamsVoice: newValue,
                                    changed: true
                                });
                            }}
                        />
                        : <div></div>}
                    {this.props.tenantData?.addOnMsftTeamsUC ?
                        <Checkbox
                            label={context.getTranslation("tenants", "addOnMsftTeamsUC")}
                            checked={this.state.addOnMsftTeamsUC}
                            styles={checkboxStyles}
                            onChange={(event, newValue) => {
                                this.setState({
                                    addOnMsftTeamsUC: newValue,
                                    changed: true
                                });
                            }}
                        />
                        : <div></div>}
                    {(this.state.licenseType !== "10" && this.props.tenantData.addOnAnalytics)
                        ? (<Checkbox
                            label={context.getTranslation("tenants", "addOnAnalytics")}
                            checked={this.state.addOnAnalytics}
                            styles={checkboxStyles}
                            onChange={(event, newValue) => {
                                this.setState({
                                    addOnAnalytics: newValue,
                                    changed: true
                                });

                            }}
                        />)
                        : <div></div>}
                    {(this.state.licenseType !== "10" && this.props.tenantData.addOnAIEntry)
                        ? (<Checkbox
                            label={context.getTranslation("tenants", "addOnAIEntry")}
                            checked={this.state.addOnAIEntry}
                            styles={checkboxStyles}
                            onChange={(event, newValue) => {
                                this.setState({
                                    addOnAIEntry: newValue,
                                    changed: true
                                });

                            }}
                        />)
                        : <div></div>}


                    {this.props.tenantData.addOnFullChat ?
                        <Checkbox
                            label={context.getTranslation("tenants", "addOnFullChat")}
                            checked={this.state.licenseType === "5" ? false : this.state.addOnFullChat}
                            disabled={this.state.licenseType === "5"}
                            styles={checkboxStyles}
                            onChange={(event, newValue) => {
                                this.setState({
                                    addOnFullChat: newValue,
                                    changed: true
                                });
                            }}
                        />
                        : <div></div>}


                    {this.props.tenantData.addOnRealTimeTranscript ? <Checkbox
                        label={context.getTranslation("tenants", "addOnRealTimeTranscript")}
                        checked={this.state.addOnRealTimeTranscript}
                        styles={checkboxStyles}
                        onChange={(event, newValue) => {
                            this.setState((prevState) => {
                                return {
                                    addOnRealTimeTranscript: newValue,
                                    changed: true
                                }
                            });
                        }}
                    /> : <div></div>}


                    {(this.state.licenseType !== "10" && this.props.tenantData.addOnCompliance)
                        ? (<Checkbox
                            label={context.getTranslation("tenants", "addOnCompliance")}
                            checked={this.state.addOnCompliance}
                            styles={checkboxStyles}
                            onChange={(event, newValue) => {
                                this.setState((prevState) => {
                                    return {
                                        addOnQualityManagement: newValue ? prevState.addOnQualityManagement : false,
                                        addOnCompliance: newValue,
                                        changed: true
                                    }
                                });
                            }}
                        />)
                        : <div></div>}

                    {this.props.tenantData.addOnQualityManagement ?
                        <Checkbox
                            disabled={!(this.state.addOnCompliance || this.state.licenseType === "10")}
                            label={context.getTranslation("tenants", "addOnQualityManagement")}
                            checked={this.state.addOnQualityManagement}
                            styles={checkboxStyles}
                            onChange={(event, newValue) => {
                                this.setState({
                                    addOnQualityManagement: newValue,
                                    changed: true
                                });
                            }}
                        />
                        : <div></div>}
                    <Checkbox
                        label={context.getTranslation("tenants", "addOnCaseManagement")}
                        checked={this.state.addOnCaseManagement}
                        styles={checkboxStyles}
                        onChange={(event, newValue) => {
                            this.setState({
                                addOnCaseManagement: newValue,
                                changed: true
                            });
                        }}
                    />
                    {this.props.tenantData.addOnZoom ?
                        <Checkbox
                            label={context.getTranslation("tenants", "addOnZoom")}
                            checked={this.state.addOnZoom}
                            styles={checkboxStyles}
                            onChange={(event, newValue) => {
                                this.setState({
                                    addOnZoom: newValue,
                                    changed: true
                                });
                            }}
                        />
                        : <div></div>}
                    {this.props.tenantData.addOnGenesys ?
                        <Checkbox
                            label={context.getTranslation("tenants", "addOnGenesys")}
                            checked={this.state.addOnGenesys}
                            styles={checkboxStyles}
                            onChange={(event, newValue) => {
                                this.setState({
                                    addOnGenesys: newValue,
                                    changed: true
                                });
                            }}
                        />
                        : <div></div>}
                    {this.props.tenantData.addOnRingcentral ?
                        <Checkbox
                            label={context.getTranslation("tenants", "addOnRingcentral")}
                            checked={this.state.addOnRingcentral}
                            styles={checkboxStyles}
                            onChange={(event, newValue) => {
                                this.setState({
                                    addOnRingcentral: newValue,
                                    changed: true
                                });
                            }}
                        />
                        : <div></div>}
                    {this.props.tenantData.addOnCloud9 ?
                        <Checkbox
                            label={context.getTranslation("tenants", "addOnCloud9")}
                            checked={this.state.addOnCloud9}
                            styles={checkboxStyles}
                            onChange={(event, newValue) => {
                                this.setState({
                                    addOnCloud9: newValue,
                                    changed: true
                                });
                            }}
                        />
                        : <div></div>}
                    {this.props.tenantData.addOnLeapXpert ?
                        <Checkbox
                            label={context.getTranslation("tenants", "addOnLeapXpert")}
                            checked={this.state.addOnLeapXpert}
                            styles={checkboxStyles}
                            onChange={(event, newValue) => {
                                this.setState({
                                    addOnLeapXpert: newValue,
                                    changed: true
                                });
                            }}
                        />
                        : <div></div>}
                    {this.props.tenantData.addOnWebex ?
                        <Checkbox
                            label={context.getTranslation("tenants", "addOnWebex")}
                            checked={this.state.addOnWebex}
                            styles={checkboxStyles}
                            onChange={(event, newValue) => {
                                this.setState({
                                    addOnWebex: newValue,
                                    changed: true
                                });
                            }}
                        />
                        : <div></div>}
                    {(this.state.addOnRingcentral || this.state.addOnCloud9 || this.state.addOnGenesys || this.state.addOnZoom || this.state.addOnLeapXpert || this.state.addOnWebex) &&
                        <TextField
                            label={context.getTranslation("tenants", "integrationUser")}
                            placeholder={context.getTranslation("tenants", "integrationUserPlaceholder")}
                            type={"text"}
                            value={this.state.integrationUser}
                            onChange={(event, newValue) => {
                                this.setState({
                                    integrationUser: newValue,
                                    changed: true
                                });
                            }} />}

                    {this.props.tenantData.addOnDynamics ?
                        <Checkbox
                            label={context.getTranslation("tenants", "addOnDynamics")}
                            checked={this.state.addOnDynamics}
                            styles={checkboxStyles}
                            onChange={(event, newValue) => {
                                this.setState({
                                    addOnDynamics: newValue,
                                    changed: true
                                });
                            }}
                        />
                        : <div></div>}
                    {this.props.tenantData.addOnEmail ?
                        <Checkbox
                            label={context.getTranslation("tenants", "addOnEmail")}
                            checked={this.state.addOnEmail}
                            styles={checkboxStyles}
                            onChange={(event, newValue) => {
                                this.setState({
                                    addOnEmail: newValue,
                                    changed: true
                                });
                            }}
                        />
                        : <div></div>}
                </div>
            )
            }
        </MyContext.Consumer>
    };

    getLicences = (context) => {

        let items = [];
        if (this.props.tenantData.licenseCompVoice != null && this.props.tenantData.licenseCompVoice.bought) {
            items.push(
                {
                    key: '6',
                    text: context.getTranslation("configuration", "complianceVoiceRecording"),

                }
            );
        }
        if (this.props.tenantData.licenseComp != null && this.props.tenantData.licenseComp.bought) {
            items.push(
                {
                    key: '1',
                    text: context.getTranslation("configuration", "complianceRecording"),

                }
            );
        }
        if (this.props.tenantData.licenseSmartVoice != null && this.props.tenantData.licenseSmartVoice.bought) {
            items.push(
                {
                    key: '8',
                    text: context.getTranslation("configuration", "smartVoice"),

                }
            );
        }
        if (this.props.tenantData.licenseSmart != null && this.props.tenantData.licenseSmart.bought) {
            items.push(
                {
                    key: '3',
                    text: context.getTranslation("configuration", "smartRecording"),

                }
            );
        }
        if (this.props.tenantData.licenseEntryVoiceRecording != null && this.props.tenantData.licenseEntryVoiceRecording.bought) {
            items.push(
                {
                    key: '13',
                    text: context.getTranslation("tenants", "licenseEntryVoiceRecording")

                }
            );
        }
        if (this.props.tenantData.licenseSmartBase != null && this.props.tenantData.licenseSmartBase.bought) {
            items.push(
                {
                    key: '11',
                    text: context.getTranslation("tenants", "licenseSmartBase")

                }
            );
        }
        if (this.props.tenantData.licenseComplianceBase != null && this.props.tenantData.licenseComplianceBase.bought) {
            items.push(
                {
                    key: '12',
                    text: context.getTranslation("tenants", "licenseComplianceBase")

                }
            );
        }

        if (this.props.tenantData.licenseAna != null && this.props.tenantData.licenseAna.bought) {
            items.push(
                {
                    key: '5',
                    text: context.getTranslation("configuration", "chatRecordingStandalone"),

                }
            );
        }
        if (this.props.tenantData.licenseRecordingInsinghtsAI != null && this.props.tenantData.licenseRecordingInsinghtsAI.bought) {
            items.push(
                {
                    key: '10',
                    text: context.getTranslation("tenants", "licenseRecordingInsinghtsAI"),

                }
            );
        }
        if (this.props.tenantData.licenseCompVoiceAna != null && this.props.tenantData.licenseCompVoiceAna.bought) {
            items.push(
                {
                    key: '7',
                    text: context.getTranslation("configuration", "complianceVoiceAnalytics"),

                }
            );
        }

        if (this.props.tenantData.licenseCompAna != null && this.props.tenantData.licenseCompAna.bought) {
            items.push(
                {
                    key: '2',
                    text: context.getTranslation("configuration", "complianceRecordingAnalytics"),

                }
            );
        }
        if (this.props.tenantData.licenseSmartVoiceAna != null && this.props.tenantData.licenseSmartVoiceAna.bought) {
            items.push(
                {
                    key: '9',
                    text: context.getTranslation("configuration", "smartVoiceAnalytics"),

                }
            );
        }

        if (this.props.tenantData.licenseSmartAna != null && this.props.tenantData.licenseSmartAna.bought) {
            items.push(
                {
                    key: '4',
                    text: context.getTranslation("configuration", "smartRecordingAnalytics"),

                }
            );
        }





        return items;

    };

    renderLicense = () => {
        return <MyContext.Consumer>
            {(context) => (
                <div>
                    <Stack>
                        {(this.props.tenantData.syncEmployeeDataFromGraph) && <>
                            <TextField
                                label={context.getTranslation("configuration", "onPremisesSamAccountName")}
                                type="text"
                                value={this.state.onPremisesSamAccountName}
                                disabled
                            />
                            <TextField
                                label={context.getTranslation("configuration", "employeeId")}
                                type="text"
                                value={this.state.employeeId}
                                disabled
                            />

                        </>}
                        <ComboBox
                            style={{ width: "300px" }}
                            placeholder="Select an option"
                            label={context.getTranslation("configuration", "license")}
                            options={this.getLicences(context)}
                            defaultSelectedKey={this.state.licenseType}
                            selectedKey={this.state.licenseType}
                            onChange={(ev, option) => {
                                const switchedEntryVoice = (this.state.licenseType === "13") !== (option.key === "13");
                                this.setState(prevState => ({
                                    licenseType: option.key,
                                    rulesRecording: switchedEntryVoice ? null : prevState.rulesRecording,
                                    addOnFullChat: option.key === "5" ? false : prevState.addOnFullChat,
                                    changed: true
                                }));
                            }}
                        />
                    </Stack>
                </div>
            )
            }
        </MyContext.Consumer>
    }

    buttenSel = () => {
        let changed = this.state.changed;
        let check = this.state.s3Check;
        let sel = false;
        if (changed) {
            sel = true;
        }
        if (check == "false" || check == "pending") {
            sel = false;
        }
        if ((check == "" || check == "true") && this.state.regionalStorageLocation == "S3Storage") {
            sel = true;
        }
        if (sel) {
            return <MyContext.Consumer>{(context) => (<PrimaryButton data-automation-id="test" text={context.getTranslation("common", "save")} allowDisabledFocus={true} onClick={() => { this.notifySave(); this.props.cl() }} />)}</MyContext.Consumer>
        }
        else {
            return <MyContext.Consumer>{(context) => (<PrimaryButton data-automation-id="test" disabled text={context.getTranslation("common", "save")} allowDisabledFocus={true} />)}</MyContext.Consumer>
        }

    };

    getUserNames = () => {
        var userNames = "";
        this.props.data.user.forEach(function (aUser) {
            userNames += aUser.name + "; ";
        });
        return userNames;
    }

    notifyDelete = async () => {
        var listId = [];
        this.props.data.user.forEach(function (aUser) {
            listId.push(aUser.id);
        });
        var data = await this.props.apol
            .mutate({
                mutation: mutationDeleteUser,
                refetchQueries: [{
                    query: queryGetConfigData,
                    variables: { auth: this.props.authorization },
                }],
                variables: {
                    auth: this.props.authorization,
                    id: listId,
                }
            });
        if (data.data.deleteUser == null || data.data.deleteUser.length == 0 || data.data.deleteUser[0].id === "error") {
            toast.info(<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "userDeleteNotSuccessful") + ((data.data.deleteUser != null && data.data.deleteUser.length > 0) ? data.data.deleteUser[0].name : "")}</>)}</MyContext.Consumer>, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } else {
            toast.info(<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "userDeleted")}</>)}</MyContext.Consumer>, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    };

    notifySave = async () => {
        var userList = [];
        this.props.data.user.forEach((aUser) => {
            userList.push({
                id: aUser.id,
                recordingRules: this.state.rulesRecording,
                access: this.state.rulesAccess,
                replay: this.state.rulesReplay,
                analytics: (this.state.rulesAnalytics != null ? this.state.rulesAnalytics.join() : null),
                groupId: null,
                addOnAnalytics: this.state.addOnAnalytics,
                addOnAIEntry: this.state.addOnAIEntry,
                addOnFullChat: this.state.licenseType === "5" ? false : this.state.addOnFullChat,
                addOnZoom: this.state.addOnZoom,
                addOnGenesys: this.state.addOnGenesys,
                addOnRingcentral: this.state.addOnRingcentral,
                addOnCloud9: this.state.addOnCloud9,
                addOnDynamics: this.state.addOnDynamics,
                addOnWebex: this.state.addOnWebex,
                addOnCompliance: this.state.addOnCompliance,
                addOnQualityManagement: this.state.addOnQualityManagement,
                addOnCaseManagement: this.state.addOnCaseManagement,
                addOnRealTimeTranscript: this.state.addOnRealTimeTranscript,
                addOnLeapXpert: this.state.addOnLeapXpert,
                addOnEmail: this.state.addOnEmail,
                addOnMsftTeamsVoice: this.state.addOnMsftTeamsVoice,
                addOnMsftTeamsUC: this.state.addOnMsftTeamsUC,
                regionalStorageLocation: this.state.regionalStorageLocation,
                regionalStorageCustomLocation: this.state.regionalStorageCustomLocation,
                integrationUser: this.state.integrationUser,
                awsAccessKeyId: this.state.awsAccessKeyId,
                awsSecretAccess: this.state.awsSecretAccess,
                awsBucketName: this.state.awsBucketName,
                awsRegion: this.state.awsRegion,
                awsServiceUrl: this.state.awsServiceUrl,
                awsType: this.state.awsType,
                license: this.state.licenseType,
                storageId: this.state.storageId
            });
        });

        var data = await this.props.apol
            .mutate({
                mutation: mutationUpdateUser,
                refetchQueries: [{
                    query: queryGetConfigData,
                    variables: { auth: this.props.authorization },
                }],
                variables: {
                    auth: this.props.authorization,
                    user: userList
                }
            });
        if (data.data.updateUser == null || data.data.updateUser[0].name === "error") {
            toast.info(<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "userUpdateNotSuccessful")}</>)}</MyContext.Consumer>, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } else {
            toast.info(<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "userUpdated")}</>)}</MyContext.Consumer>, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    };

    notifyReset = async () => {
        var userList = [];


        this.props.data.user.forEach((aUser) => {
            userList.push({
                id: aUser.id,
                recordingRules: this.state.rulesRecording,
                access: this.state.rulesAccess,
                replay: this.state.rulesReplay,
                analytics: (this.state.rulesAnalytics != null ? this.state.rulesAnalytics.join() : null),
                groupId: null,
                addOnAnalytics: this.state.addOnAnalytics,
                addOnAIEntry: this.state.addOnAIEntry,
                addOnFullChat: this.state.addOnFullChat,
                addOnZoom: this.state.addOnZoom,
                addOnGenesys: this.state.addOnGenesys,
                addOnRingcentral: this.state.addOnRingcentral,
                addOnCloud9: this.state.addOnCloud9,
                addOnDynamics: this.state.addOnDynamics,
                addOnWebex: this.state.addOnWebex,
                addOnCompliance: this.state.addOnCompliance,
                addOnQualityManagement: this.state.addOnQualityManagement,
                addOnRealTimeTranscript: this.state.addOnRealTimeTranscript,
                addOnLeapXpert: this.state.addOnLeapXpert,
                addOnEmail: this.state.addOnEmail,
                addOnMsftTeamsVoice: this.state.addOnMsftTeamsVoice,
                addOnMsftTeamsUC: this.state.addOnMsftTeamsUC,
                addOnCaseManagement: this.state.addOnCaseManagement,
            });
        });
        var data = await this.props.apol
            .mutate({
                mutation: mutationResetUser,
                refetchQueries: [{
                    query: queryGetConfigData,
                    variables: { auth: this.props.authorization },
                }],
                variables: {
                    auth: this.props.authorization,
                    user: userList
                }
            });
        if (data.data.resetUser == null || data.data.resetUser[0].name === "error") {
            toast.info(<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "userResetNotSuccessful")}</>)}</MyContext.Consumer>, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } else {
            toast.info(<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "userResetSuccessful")}</>)}</MyContext.Consumer>, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    };

    renderOptions = () => {

        return (
            <MyContext.Consumer>
                {(context) => (
                    <div>
                        <hr />
                        <p >
                            <MyContext.Consumer>{(context) => (<PrimaryButton data-automation-id="test" text={context.getTranslation("common", "save")} allowDisabledFocus={true} disabled={this.state.changed ? false : true} onClick={() => { this.notifySave(); this.props.cl() }} />)}</MyContext.Consumer>
                            <br />
                            <br />
                            <DefaultButton
                                onClick={() => { this.notifyReset(); this.props.cl() }}
                                style={{ background: "red", color: "white" }}
                                data-automation-id="test"
                                text={context.getTranslation("common", "reset")}
                                allowDisabledFocus={true}
                            />
                        </p>
                        <p>

                            <Popup trigger={
                                <DefaultButton
                                    data-automation-id="test"
                                    style={{ background: "red", color: "white" }}
                                    text={context.getTranslation("configuration", "deleteUser")}
                                    allowDisabledFocus={true}
                                />}
                                modal >
                                {close => (
                                    <div>
                                        <div className="ms-Grid" dir="ltr">
                                            <p>{context.getTranslation("configuration", "deleteUserQuestion")} {this.getUserNames()} ?</p>
                                            <p>
                                                <DefaultButton
                                                    onClick={
                                                        () => {
                                                            this.notifyDelete();
                                                            close();
                                                            this.props.cl()
                                                        }
                                                    }
                                                    data-automation-id="test"
                                                    text={context.getTranslation("common", "yes")}
                                                    allowDisabledFocus={true}
                                                />

                                                <PrimaryButton
                                                    data-automation-id="test"
                                                    text={context.getTranslation("common", "no")}
                                                    allowDisabledFocus={true}
                                                    onClick={
                                                        () => {
                                                            close();
                                                            this.props.cl()

                                                        }
                                                    }
                                                />
                                            </p>
                                        </div>
                                    </div>
                                )}
                            </Popup>

                        </p>

                    </div>
                )
                }
            </MyContext.Consumer>
        );

    };

    getItems = () => {
        let _allItems = [];

        return _allItems;
    }
    _columns = [
        { key: 'column1', name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "userId")}</>)}</MyContext.Consumer>, fieldName: 'userId', minWidth: 20, maxWidth: 160, isResizable: true },
        { key: 'column2', name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "systemId")}</>)}</MyContext.Consumer>, fieldName: 'systemId', minWidth: 20, maxWidth: 160, isResizable: true },
        { key: 'column3', name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "tenantId")}</>)}</MyContext.Consumer>, fieldName: 'tenantId', minWidth: 20, maxWidth: 160, isResizable: true },
        {
            key: 'column4',
            name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "options")}</>)}</MyContext.Consumer>,
            className: classNames.fileIconCell,
            iconClassName: classNames.fileIconHeaderIcon,
            ariaLabel: 'Column operations for File type, Press to sort on File type',
            isIconOnly: true,
            fieldName: 'name',
            minWidth: 16,
            maxWidth: 16,
            onColumnClick: this._onColumnClick,
            onRender: (item) => {
                return <MyContext.Consumer>
                    {(context) => (
                        <Popup trigger={<a style={{ cursor: "pointer" }}><Icon iconName={"RemoveLink"} /></a>} modal>
                            {close => (

                                <div>
                                    <h2>{context.getTranslation("configuration", "unlinkAccount")} : {item.value}</h2>

                                    <p><DefaultButton onClick={close} data-automation-id="test" text={context.getTranslation("common", "delete")} allowDisabledFocus={true} /><PrimaryButton onClick={close} data-automation-id="test" text={context.getTranslation("common", "cancel")} allowDisabledFocus={true} /></p>
                                </div>
                            )}
                        </Popup>
                    )
                    }
                </MyContext.Consumer>

            }
        }
    ];
    _columnsPopup = [
        { key: 'column1', name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "userId")}</>)}</MyContext.Consumer>, fieldName: 'userId', minWidth: 20, maxWidth: 160, isResizable: true },
        { key: 'column2', name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "systemId")}</>)}</MyContext.Consumer>, fieldName: 'systemId', minWidth: 20, maxWidth: 160, isResizable: true },
        { key: 'column3', name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "tenantId")}</>)}</MyContext.Consumer>, fieldName: 'tenentId', minWidth: 20, maxWidth: 160, isResizable: true }, {
            key: 'column4',
            name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "options")}</>)}</MyContext.Consumer>,
            className: classNames.fileIconCell,
            iconClassName: classNames.fileIconHeaderIcon,
            ariaLabel: 'Column operations for File type, Press to sort on File type',
            isIconOnly: true,
            fieldName: 'name',
            minWidth: 16,
            maxWidth: 16,
            onColumnClick: this._onColumnClick,
            onRender: (item) => {
                return <Popup trigger={<a style={{ cursor: "pointer" }}><Icon iconName={"RemoveLink"} /></a>} position={"center"} closeOnDocumentClick>
                    <a style={{ cursor: "pointer", width: "16px", height: "16px" }}><Icon iconName={"Delete"} /></a>
                </Popup>
            }
        }
    ];

    renderUserMapping = () => {
        if (this.state.size > 1) {
            return (<div></div>);
        }

        return (
            <MyContext.Consumer>
                {(context) => (
                    <div>
                        <hr />
                        <h4>{context.getTranslation("configuration", "linkedAccounts")}</h4>
                        <DetailsList
                            key={"001"}
                            items={this.getItems()}
                            columns={this._columns}
                            layoutMode={DetailsListLayoutMode.fixedColumns}
                            selection={false}
                            selectionMode={SelectionMode.none}
                            selectionPreservedOnEmptyClick={false}
                            onItemInvoked={this._onItemInvoked}
                        />

                        <p className="padding-default--tb">

                            <Popup trigger={

                                <PrimaryButton
                                    data-automation-id="test"
                                    text={context.getTranslation("configuration", "linkAccount")}
                                    allowDisabledFocus={true}
                                />
                            } modal >

                                {close => (
                                    <div>
                                        <div className="ms-Grid" dir="ltr">
                                            <div className="ms-Grid-row">

                                                <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">

                                                    <h2>{context.getTranslation("configuration", "linkAccount")}</h2>

                                                    <div className="padding-default-b">
                                                        <Persona text={this.props.data.user[0].name} size={PersonaSize.size32} />
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="ms-Grid-row">

                                                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4">
                                                    <form>
                                                        <TextField label={context.getTranslation("configuration", "userId")} />
                                                        <TextField label={context.getTranslation("configuration", "systemId")} />
                                                        <TextField label={context.getTranslation("configuration", "tenantId")} />
                                                        <p className="padding-default--tb">
                                                            <DefaultButton data-automation-id="test" text={context.getTranslation("configuration", "add")} allowDisabledFocus={true} />
                                                        </p>
                                                    </form>
                                                </div>

                                                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8">

                                                    <DetailsList
                                                        key={"002"}
                                                        items={this.getItems()}
                                                        columns={this._columnsPopup}
                                                        layoutMode={DetailsListLayoutMode.fixedColumns}
                                                        selection={false}
                                                        selectionMode={SelectionMode.none}
                                                        selectionPreservedOnEmptyClick={false}
                                                        onItemInvoked={this._onItemInvoked}
                                                    />

                                                </div>

                                            </div>

                                            <div className="ms-Grid-row">
                                                <div className="ms-Grid-col ms-sm12">
                                                    <p className="padding-default--tb">
                                                        <PrimaryButton
                                                            onClick={() => { close(); this.notifySave() }}
                                                            data-automation-id="test"
                                                            text={context.getTranslation("common", "save")}
                                                            allowDisabledFocus={true}
                                                        />

                                                        <DefaultButton
                                                            onClick={close}
                                                            data-automation-id="test"
                                                            text={context.getTranslation("common", "cancel")}
                                                            allowDisabledFocus={true}
                                                        />
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                                }

                            </Popup>
                        </p>
                    </div>
                )
                }
            </MyContext.Consumer>
        );
    }

}
//this.props.data.user[0]
